
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1650505594904",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2103",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M342.3476 537.617447c-3.675716 4.643764-18.482957 21.198811-21.48329 25.360598-14.660908 20.210297-18.532075 52.054563-12.870122 71.506591 8.032954 27.384697 35.465746 30.488385 55.837726 32.511461 47.12632 4.736884 95.028307 1.563612 142.640698 1.563612 46.447868 0 92.848665-0.690732 139.251507 0.276293 27.433816 0.483001 50.513464-7.058766 61.934584-32.902364 12.19167-27.567869 5.948479-53.595662-14.760169-75.760474-7.306406-7.748475-14.902408-15.382339-22.500457-22.946618-17.368576-17.405415-17.032932-34.834366-1.64343-53.595662 14.32117-17.428951 28.983101-34.948977 41.031509-53.918004 65.029062-102.270245 42.335201-235.628532-52.209082-311.389006C562.4536 41.965787 424.167071 49.02353 338.573647 134.465504c-92.996021 92.821035-77.948303 245.998717 4.839215 349.740476C362.524129 508.095064 353.81477 523.20111 342.3476 537.617447L342.3476 537.617447zM897.2272 784.765337c-0.190335-49.916876-21.481244-73.6453-70.638827-73.737398-213.137285-0.391926-426.227498-0.276293-639.362736 0.298805-48.819892 0.092098-69.480444 21.866007-70.110801 69.874417-0.290619 22.441105-0.049119 44.881187-0.049119 69.851904l780.161483 0C897.2272 827.255057 897.325437 805.964148 897.2272 784.765337L897.2272 784.765337zM160.757822 957.208804 851.844593 957.208804l0-71.115688L160.757822 886.093117 160.757822 957.208804 160.757822 957.208804zM160.757822 957.208804",
        "p-id": "2104",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  